import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TZ = "America/Argentina/Buenos_Aires";

let offsetMs = 0;

export function useAhoraBA() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    let vivo = true;
    const sync = async () => {
      try {
        const { data } = await api.get("/demo/ahora");
        if (vivo) offsetMs = new Date(data.ahora).getTime() - Date.now();
      } catch { /* sin sesión o sin red: hora local */ }
    };
    sync();
    const s = setInterval(sync, 10000);
    const t = setInterval(() => setNow(new Date(Date.now() + offsetMs)), 1000);
    return () => { vivo = false; clearInterval(s); clearInterval(t); };
  }, []);
  return now;
}

export function ahoraBADate() {
  return new Date(Date.now() + offsetMs);
}

export function horaBA(now, conSegundos = true) {
  return new Intl.DateTimeFormat("es-AR", {
    timeZone: TZ, hour: "2-digit", minute: "2-digit",
    ...(conSegundos ? { second: "2-digit" } : {}), hour12: false,
  }).format(now);
}

export function fechaBA(now) {
  const partes = new Intl.DateTimeFormat("es-AR", {
    timeZone: TZ, weekday: "long", day: "2-digit", month: "2-digit", year: "numeric",
  }).formatToParts(now);
  const get = (t) => partes.find((p) => p.type === t)?.value || "";
  const semana = get("weekday");
  return `${semana.charAt(0).toUpperCase() + semana.slice(1)} ${get("day")}/${get("month")}/${get("year")}`;
}

export function fechaLargaBA(now) {
  const partes = new Intl.DateTimeFormat("es-AR", {
    timeZone: TZ, weekday: "long", day: "numeric", month: "long", year: "numeric",
  }).formatToParts(now);
  const get = (t) => partes.find((p) => p.type === t)?.value || "";
  const semana = get("weekday");
  return `${semana.charAt(0).toUpperCase() + semana.slice(1)} ${get("day")} de ${get("month")} de ${get("year")}`;
}

export function fechaLargaISO(iso) {
  return fechaLargaBA(new Date(`${iso}T12:00:00`));
}

export function hoyISOBA() {
  return ahoraBADate().toLocaleDateString("en-CA", { timeZone: TZ });
}

export function shiftISO(iso, dias) {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + dias);
  return d.toLocaleDateString("en-CA");
}
